import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { SubtitleText } from '@prisjakt/ui/text/variants';
import Button from '@prisjakt/ui-button';

const meterHeight = '6px';

export const Summary = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  color: ${p => p.theme.text.quaternary};
  margin-bottom: ${layout.spacing.small};
`;

export const Distribution = styled.div`
  display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: ${layout.spacing.xSmall};
  row-gap: ${layout.spacing.xSmall};
  align-items: center;
  margin-top: ${layout.spacing.xSmall};
`;

export const SummaryWrapper = styled.div`
  column-gap: ${layout.spacing.xSmall};

  display: grid;
  grid-template-rows: auto auto;

  ${media.mediumDown`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  `};
`;

export const Meter = styled.div`
  height: ${meterHeight};
  background: ${p => p.theme.lines.primary};
  border-radius: ${meterHeight};
`;

type IndicatorProps = {
  width: string;
};

export const Indicator = styled.div<IndicatorProps>`
  width: ${p => p.width};
  height: 100%;
  background: ${p => p.theme.lines.highlight};
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
`;

export const MeterLabel = styled.span`
  white-space: nowrap;
  font-weight: 600;
  display: flex;
  align-items: center;
  column-gap: 4px;
  color: ${p => p.theme.text.primary};
`;

export const MeterCount = styled.span`
  color: ${p => p.theme.text.quaternary};
  font-size: ${layout.measurements.fontSizeSmall};
`;

export const Score = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  font-size: 24px;
  color: ${p => p.theme.text.primary};
  margin-left: ${layout.spacing.xSmall};
  margin-right: ${layout.spacing.xxSmall};
`;

export const PromptButton = styled(Button)`
  width: 100%;
  margin-bottom: ${layout.spacing.medium};
  font-weight: normal;
  font-size: ${layout.measurements.fontSizeNormal};
  text-transform: none;
`;

export const Title = styled(SubtitleText)`
  margin-bottom: ${layout.measurements.spacingSmall};
`;

export const StarRate = styled.span`
  line-height: 1;
  margin-right: ${layout.measurements.spacingTiny};
`;
